'use strict';

module.exports = {
  assortment: 'scenario-assortments-panel',
  management: 'scenario-management-panel',
};
